export const OfficeLoginTranslations = {
    en: {
        officeLogin: {
            title: 'Office Login',
            emailLabel: 'Office Email',
            emailPlaceholder: 'Enter your office email',
            passwordLabel: 'Password',
            passwordPlaceholder: 'Enter your password',
            loginButton: 'Login',
            cancelButton: 'Cancel',
            loggingIn: 'Logging in...',
            forgotPassword: 'Forgot your password?',
            closeButton: 'Close login form',
            successMessage: 'Login successful! Redirecting...',
            errors: {
                usernameRequired: 'Username is required',
                passwordRequired: 'Password is required',
                passwordLength: 'Password must be at least 6 characters',
                loginFailed: 'Login failed. Please try again.',
                invalidCredentials: 'Invalid credentials. Please try again.'
            }
        },
    },
    mr: {
        officeLogin: {
            title: 'कार्यालय लॉगिन',
            emailLabel: 'कार्यालयीन ईमेल',
            emailPlaceholder: 'तुमचा कार्यालयीन ईमेल टाका',
            passwordLabel: 'पासवर्ड',
            passwordPlaceholder: 'तुमचा पासवर्ड टाका',
            loginButton: 'लॉगिन',
            cancelButton: 'रद्द करा',
            loggingIn: 'लॉगिन होत आहे...',
            forgotPassword: 'पासवर्ड विसरलात?',
            closeButton: 'लॉगिन फॉर्म बंद करा',
            successMessage: 'लॉगिन यशस्वी! पुनर्निर्देशित करत आहे...',
            errors: {
                usernameRequired: 'वापरकर्तानाव आवश्यक आहे',
                passwordRequired: 'पासवर्ड आवश्यक आहे',
                passwordLength: 'पासवर्ड किमान ६ वर्णांचा असावा',
                loginFailed: 'लॉगिन अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
                invalidCredentials: 'अवैध प्रमाणपत्रे. कृपया पुन्हा प्रयत्न करा.'
            }
        },

    }

};